// @flow 

export const SET_ROOM_DETAILS           = "SET_ROOM_DETAILS";
export const INTERNET_SPEED             = "INTERNET_SPEED";
export const SET_USER_DETAIL            = "SET_USER_DETAIL";
export const SET_DOMINENT_SPEAKER       = "SET_DOMINENT_SPEAKER";
export const ADD_MESSAGE                = "ADD_MESSAGE";
export const RETRY_STREAM               = "RETRY_STREAM";
export const HIDE_CHAT_BADGE            = "HIDE_CHAT_BADGE";
export const PARTICIPANTS_NETWORK_SPEED = "PARTICIPANTS_NETWORK_SPEED";

export const GET_COUNTRIES_LIST                 = "GET_COUNTRIES_LIST";
export const GOOGLE_MAP_ADDRESS             =  'GOOGLE_MAP_ADDRESS';
export const ADDRESS_VERIFIED                       =  'ADDRESS_VERIFIED';


/* for auth */
export const LOGIN_SUCCESS              =   "LOGIN_SUCCESS";
export const SIGNUP_SUCCESS             =   "SIGNUP_SUCCESS";
export const SOCIAL_SIGNUP              =   "SOCIAL_SIGNUP";
export const IS_SOCIAL_SIGNUP_FROM      =   "IS_SOCIAL_SIGNUP_FROM"
export const USER_STATUS                =   "USER_STATUS";
export const USER_OFFLINE_STATUS        =   "USER_OFFLINE_STATUS";
export const CHECK_ACCOUNT              =   "CHECK_ACCOUNT";
export const FETCH_USER_COUNTRY_DETAILS =   "FETCH_USER_COUNTRY_DETAILS"
export const SUB_PAGES                  =   "SUB_PAGES";
export const SUB_TABS                   =   "SUB_TABS";
export const FETCH_CURRENCY_LISTING     =   "FETCH_CURRENCY_LISTING" 
export const FETCH_CARD_PAYMENT         =   "FETCH_CARD_PAYMENT" 
export const FETCH_CARD_LISTING         =   "FETCH_CARD_LISTING"
export const FETCH_PAYMENT_LISTING      =   "FETCH_PAYMENT_LISTING"

/* for meetings */
export const UPCOMING_MEETING_LIST      = "UPCOMING_MEETING_LIST";
export const PAST_MEETING_LIST          = "PAST_MEETING_LIST";
export const MEETING_DETAIL             = "MEETING_DETAIL";
export const TODAY_MEETING_LIST         = "TODAY_MEETING_LIST";
export const RECORDING_LIST             = "RECORDING_LIST";
export const CHANGE_URL                 = "CHANGE_URL";
export const MEETINGS_LIST              = "MEETINGS_LIST";
export const MEETINGS_COUNT             = "MEETINGS_COUNT";
export const TOTAL_MEETINGS             = "TOTAL_MEETINGS";
export const TIMEZONE_LIST              = "TIMEZONE_LIST";
export const EDIT_MEET_DATA             = "EDIT_MEET_DATA";
export const DOCUMENTS_LIST             = "DOCUMENTS_LIST";
export const NEW_MESSAGE_COUNT          = "NEW_MESSAGE_COUNT";
export const MEETINGS_SETTINGS          = "MEETINGS_SETTINGS";
export const AUTHORIZED_USER            = "AUTHORIZED_USER";
export const PARTICIPANT_IS_HOST        = "PARTICIPANT_IS_HOST";
export const INVITATION_LIST            = "INVITATION_LIST"; 

/* for chat window */
export const CHAT_WINDOW_USERS          = "CHAT_WINDOW_USERS";
export const REMOVE_CHAT_WINDOW_USER    = "REMOVE_CHAT_WINDOW_USER";

export const SIDE_NAVBAR_MEMBER_LIST    = "SIDE_NAVBAR_MEMBER_LIST";

export const SHOW_LOADER                = 'SHOW_LOADER';
export const MEETING_COUNTS             = 'MEETING_COUNTS';
export const FOLLOWER_WEEKLY_DETAILS    = 'FOLLOWER_WEEKLY_DETAILS';
export const SET_RESET_PASSWORD_TOKEN   = 'SET_RESET_PASSWORD_TOKEN';
export const FETCH_USER_DETAILS         = 'FETCH_USER_DETAILS';
export const FETCH_EXTENSION_LISTING    = 'FETCH_EXTENSION_LISTING';
export const FTECH_FOLLOWERS_LISTING    = 'FTECH_FOLLOWERS_LISTING';
export const SELECTED_CHAT_USER         = 'SELECTED_CHAT_USER';
export const OPEN_MAIN_PAGE_SECTION     = 'OPEN_MAIN_PAGE_SECTION';
export const FTECH_DAYS_AND_DATES       = 'FTECH_DAYS_AND_DATES';
export const FTECH_MEETING_LISTING      = 'FTECH_MEETING_LISTING';
export const CREATE_GROUP_MEMBER        = 'CREATE_GROUP_MEMBER';
export const OPEN_CHAT_INFO_PAGE        =  'OPEN_CHAT_INFO_PAGE';
export const FETCH_GROUP_UNIQUEKEY      =  'FETCH_GROUP_UNIQUEKEY';

// for call window

export const FETCH_RECENT_CALL_LISTING      =   'FETCH_RECENT_CALL_LISTING'
export const CALL_LISTING_COUNT             =   'CALL_LISTING_COUNT'
export const ALL_RECORDING_COUNT            =   'ALL_RECORDING_COUNT'
export const FETCH_ALL_RECORDING_LISTING    =   'FETCH_ALL_RECORDING_LISTING'
export const DESTINATION_NUMBER             =   'DESTINATION_NUMBER'
export const FETCH_ALL_DESTINATION_LISTING  =   'FETCH_ALL_DESTINATION_LISTING'
export const FETCH_CALL_DETAILS             =   'FETCH_CALL_DETAILS'
export const FETCH_ASSIGNED_NUMBER_LIST     =   'FETCH_ASSIGNED_NUMBER_LIST'
export const NAVIGATE_TO_SCHEDULE_MEETING   =   'NAVIGATE_TO_SCHEDULE_MEETING'
export const FETCH_SCHEDULED_CALL_LISTING   =   'FETCH_SCHEDULED_CALL_LISTING'
export const FORCE_CALL                     =   'FORCE_CALL'
export const FETCH_TAGGED_NUMBER_LISTING    =   'FETCH_TAGGED_NUMBER_LISTING'
export const FETCH_ISTAGGED_NUMBER          =   'FETCH_ISTAGGED_NUMBER'
export const FETCH_PLANNER_DETAILS          =   "FETCH_PLANNER_DETAILS"
export const INDIVIDUAL_CONTACT_CALL_HISTORY    =   "INDIVIDUAL_CONTACT_CALL_HISTORY"
export const FORCE_OPEN_DIALPAD             =   "FORCE_OPEN_DIALPAD"
export const FETCH_VOICEMAIL_LISTING        =   "FETCH_VOICEMAIL_LISTING"
export const GET_TAG_LISTING                =   "GET_TAG_LISTING"
export const FETCH_SMS_CHAT_LISTING         =   "FETCH_SMS_CHAT_LISTING"
export const FETCH_SMS_CHAT_HISTORY         =   "FETCH_SMS_CHAT_HISTORY"

// FOR PHONESYSTEMCALL_LISTING_COUNT
export const PHONESYSTEM_TEAM               = 'PHONESYSTEM_TEAM'
export const PHONESYSTEM_TEAM_COUNT               = 'PHONESYSTEM_TEAM_COUNT'
export const BUISNESS_HOUR                  = 'BUISNESS_HOUR'
export const BUISNESS_HOUR_COUNT            = 'BUISNESS_HOUR_COUNT'
export const VOICEFILES_LIST                  = 'VOICEFILES_LIST'
export const VOICEFILES_LIST_COUNT               = 'VOICEFILES_LIST_COUNT'
export const SELECTED_GROUP_CHAT_USER       =   'SELECTED_GROUP_CHAT_USER'
export const TEAM_NAME                      =   'TEAM_NAME'
export const FETCH_TEAM_CHAT                =   'FETCH_TEAM_CHAT'
export const SELECTED_CHAT_TYPE             =   'SELECTED_CHAT_TYPE'
export const FETCH_DID_NUMBER_LISTING       =   "FETCH_DID_NUMBER_LISTING"

// FOR JITSI MEET
export const INVITE_FOR_MEET                =   'INVITE_FOR_MEET'
export const INVITE_FOR_LOBBY               =   'INVITE_FOR_LOBBY'
export const MEETING_DETAILS                =   'MEETING_DETAILS'
export const IS_VISIBLE_LOBBY               =   'IS_VISIBLE_LOBBY'
export const KNOCKING_LIST_LOBBY            =   'KNOCKING_LIST_LOBBY'
export const DEFAULT_LOBBY_IS_ON            =   'DEFAULT_LOBBY_IS_ON'

// FOR PHONESYSTEM 

export const NAVIGATE_TO_PHONESYSTEM        =   'NAVIGATE_TO_PHONESYSTEM'
export const FETCH_TEAM_LISTING             =   'FETCH_TEAM_LISTING'
export const FETCH_IVR_LISTING              =   'FETCH_IVR_LISTING' 
export const VIEW_EXISTING_TEAM             =   'VIEW_EXISTING_TEAM'
export const VIEW_EXTENSION                 =   'VIEW_EXTENSION'
export const FETCH_BUSINESS_HOUR_LISTING    =   'FETCH_BUSINESS_HOUR_LISTING'
export const VIEW_BUSINESS_HOUR             =   'VIEW_BUSINESS_HOUR'
export const FETCH_IVR_GREETING_LISTING     =   'FETCH_IVR_GREETING_LISTING' 
export const FETCH_DID_LISTING              =   'FETCH_DID_LISTING' 
export const FETCH_DESTINATION_LISTING      =   'FETCH_DESTINATION_LISTING' 
export const FETCH_RULE_LISTING             =   'FETCH_RULE_LISTING' 
export const VIEW_RULE_LIST                 =   'VIEW_RULE_LIST'  
export const NAVIGATE_TO_SETTING            =   "NAVIGATE_TO_SETTING"
export const FETCH_NOTIFICATION_LISTING     =   'FETCH_NOTIFICATION_LISTING'
export const FETCH_IVR_MENU_LISTING         =   "FETCH_IVR_MENU_LISTING"
export const FETCH_CALL_FLOW_LISTING        =   "FETCH_CALL_FLOW_LISTING"

// FOR CONTACTS
export const CONTACT_LISTING                =   'CONTACT_LISTING'
export const NXA_CONTACT_LISTING            =   'NXA_CONTACT_LISTING'



// FOR BUY 
export const FETCH_BUY_DEVICE_LISTING       =   'FETCH_BUY_DEVICE_LISTING'
export const FETCH_BUY_INTERNET_LISTING     =   'FETCH_BUY_INTERNET_LISTING'
export const FETCH_BUY_TELKOM_LTE_LISTING   =   'FETCH_BUY_TELKOM_LTE_LISTING'
export const FETCH_BUY_MTN_LTE_LISTING      =   'FETCH_BUY_MTN_LTE_LISTING'
export const FTECH_DEVICE_DETAILS           =   'FTECH_DEVICE_DETAILS'
export const FTECH_DEVICE_DELIVERY_ADDRESS  =  'FTECH_DEVICE_DELIVERY_ADDRESS'
export const FETCH_DEVICE_PRODUCT_CART      =   'FETCH_DEVICE_PRODUCT_CART' 
export const NAVIGATE_TO_BUY                =   'NAVIGATE_TO_BUY'
export const FETCH_TOTAL_AMOUNT             =   'FETCH_TOTAL_AMOUNT'
export const NAVIGATE_TO_ORDER_ITEMS        =   'NAVIGATE_TO_ORDER_ITEMS'

// FOR CHOOSE NUMBER
export const AVAILABLE_DID_NUMBERS          =   'AVAILABLE_DID_NUMBERS'
export const AVAILABLE_CITY_LIST            =   'AVAILABLE_CITY_LIST'
export const CHOOSEN_NUMBER_INFO            =   'CHOOSEN_NUMBER_INFO'
// FOR CHOOSE PLAN
export const PLANS_LIST                     =   'PLANS_LIST'
export const CHOOSEN_PLAN_INFO              =   'CHOOSEN_PLAN_INFO'
// FOR PAYMENTS
export const ORDER_SUMMARY                  =   'ORDER_SUMMARY'
export const PAYMENT_TOKEN                  =   'PAYMENT_TOKEN'

//Video Record Listing
export const VIDEO_RECORDING_LIST           =   'VIDEO_RECORDING_LIST'
export const RECORDING_COUNT                =   'RECORDING_COUNT'
export const GET_FULL_SCREEN_USERID         =   "GET_FULL_SCREEN_USERID"
export const ACTIVATE_GUEST_SHARE_SCREEN    =   "ACTIVATE_GUEST_SHARE_SCREEN"
export const ADDITIONAL_MODERATOR           =   "ADDITIONAL_MODERATOR"
export const IS_RECORDING_ON                =   "IS_RECORDING_ON"

//GOOGLE MAPS
export const MAP_ADDRESS                    =   'MAP_ADDRESS' 

// FOR NOTES

export const FETCH_PROFILE_INFO_DATA        =  'FETCH_PROFILE_INFO_DATA'
export const NAVIGATE_TO_NOTES              =  'NAVIGATE_TO_NOTES'
export const NAVIGATE_TO_CALL_INFO          =  'NAVIGATE_TO_CALL_INFO'
export const FETCH_NOTES_LISTING            =  'FETCH_NOTES_LISTING'
export const CLOUD_NOTES_LISTING            =   'CLOUD_NOTES_LISTING'


// FOR DASHBOARD

export const FETCH_DASHBOARD_DETAILS        =  'FETCH_DASHBOARD_DETAILS'

// PAYMENT INFO 

export const PAYMENT_INFO                   =   'PAYMENT_INFO'

//WIDGET

export const TOASTR                         =   'TOASTR'


// PLANNER

export const NAVIGATE_TO_PLANNER            =   'NAVIGATE_TO_PLANNER'
export const NAVIGATE_TO_POWER_APPS         =   'NAVIGATE_TO_POWER_APPS'

// REPORTS
export const REPORTS_DATA                   =   'REPORTS_DATA'
export const CALL_HISTORY                   =   'CALL_HISTORY'
export const CALL_REPORT                    =   'CALL_REPORT'


// SUPPORT

export const FETCH_PROBLEM_CATEGORY_LIST    =   "FETCH_PROBLEM_CATEGORY_LIST"



// RICA 

export const RICA_COMPANY_VERIFICATION      =   "RICA_COMPANY_VERIFICATION"
export const RICA_PORTING_PROCESS           =   "RICA_PORTING_PROCESS"
export const SELECTED_PLAN_DURING_SIGNUP    =   "SELECTED_PLAN_DURING_SIGNUP"
export const IS_NXA_DEMO_BOOKING            =   "IS_NXA_DEMO_BOOKING" 
export const FETCH_ONBOARD_PROCESS_STATICS  =   "FETCH_ONBOARD_PROCESS_STATICS"



